var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('h1',[_vm._v("Minesweeper Heatmap")])])],1),_c('v-row',[_c('v-col',[_c('Board')],1)],1),_c('v-row',[_c('v-col',[_c('BoardControl')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }